/* Seguimiento del pedido — Glucody (ago-2026)
   Enruta al transportista elegido con la plantilla de URL de su bloque.
   Cada transportista define su URL con [NUM] y, opcionalmente, una expresión
   de validación; aquí no hay lógica de negocio horneada.

   El botón nace DESHABILITADO en el HTML y lo habilita este script: si el JS
   no llega a cargar (CDN lento, bloqueador), el formulario no puede enviarse
   de forma nativa. Sin ese guard, el envío GET reemplazaba el query string y
   tiraba al usuario a otra página perdiendo lo que había escrito. */
(function () {
  if (window.__glucodyTrackLoaded) return;
  window.__glucodyTrackLoaded = true;

  // Tope de longitud antes de aplicar la regex: una expresión mal escrita en
  // el ajuste "Formato esperado" puede tardar minutos con textos largos
  // (retroceso catastrófico) y congelar la pestaña.
  var MAX_LEN = 40;

  function init(root) {
    var forms = (root || document).querySelectorAll('[data-track-form]');
    Array.prototype.forEach.call(forms, function (form) {
      if (form.dataset.trackReady) return;
      form.dataset.trackReady = '1';

      var sel = form.querySelector('[data-track-carrier]');
      var num = form.querySelector('[data-track-number]');
      var hint = form.querySelector('[data-track-hint]');
      var err = form.querySelector('[data-track-error]');
      var btn = form.querySelector('[data-track-submit]');
      var helpBtn = form.querySelector('[data-track-help]');
      var scope = form.closest('.glucody-track') || document;
      var modal = scope.querySelector('[data-track-modal]');
      var mTitle = scope.querySelector('[data-track-modal-title]');
      var mBody = scope.querySelector('[data-track-modal-body]');
      var mClose = scope.querySelector('[data-track-modal-close]');
      if (!sel || !num) return;

      if (btn) btn.disabled = false; // el JS está vivo: ya se puede enviar
      var sending = false;

      function opt() { return sel.options[sel.selectedIndex]; }

      function clearError() {
        if (err) err.hidden = true;
        num.removeAttribute('aria-invalid');
      }

      function fail(msg) {
        if (err) {
          if (msg) err.textContent = msg;
          err.hidden = false;
        }
        num.setAttribute('aria-invalid', 'true');
        // No devolvemos el foco si ya lo tiene: focus() sobre el elemento
        // enfocado NO dispara evento, y el lector de pantalla se quedaba mudo.
        if (document.activeElement !== num) num.focus();
      }

      // La ayuda y el teclado cambian con el transportista: el número que
      // sirve NO es el mismo en todos (Nacex pide albarán numérico; Correos
      // y SEUR llevan letras, y con inputmode numeric no se podían teclear).
      function syncCarrier() {
        var o = opt();
        if (hint) hint.textContent = o ? (o.getAttribute('data-hint') || '') : '';
        var rule = o ? (o.getAttribute('data-pattern') || '') : '';
        num.setAttribute('inputmode', /^\^?\[0-9\]/.test(rule) ? 'numeric' : 'text');
        // El enlace del aviso solo aparece si ese transportista tiene algo que contar
        if (helpBtn) helpBtn.hidden = !(o && (o.getAttribute('data-help') || '').trim());
        clearError();
      }

      sel.addEventListener('change', function () {
        // El número del transportista anterior no vale para el nuevo: si se
        // reenvía, el transportista responde "no existe" y confunde.
        num.value = '';
        syncCarrier();
      });
      num.addEventListener('input', clearError);
      syncCarrier();

      if (helpBtn && modal) {
        helpBtn.addEventListener('click', function () {
          var o = opt();
          if (!o) return;
          if (mTitle) mTitle.textContent = o.textContent.trim();
          if (mBody) mBody.textContent = o.getAttribute('data-help') || '';
          if (typeof modal.showModal === 'function') modal.showModal();
          else modal.setAttribute('open', '');
        });
        if (mClose) mClose.addEventListener('click', function () {
          if (typeof modal.close === 'function') modal.close();
          else modal.removeAttribute('open');
          helpBtn.focus(); // devolver el foco a donde estaba
        });
        // Clic en el fondo oscuro cierra
        modal.addEventListener('click', function (e) {
          if (e.target === modal) {
            if (typeof modal.close === 'function') modal.close();
            else modal.removeAttribute('open');
          }
        });
      }

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (sending) return; // 3 clics rápidos abrían 3 pestañas
        var o = opt();
        if (!o) return;

        // Los transportistas imprimen el código con guiones/puntos de adorno
        var value = (num.value || '')
          .replace(/[\s\-./]/g, '')
          .toUpperCase();

        if (!value) return fail();
        if (value.length > MAX_LEN) return fail();

        var rule = o.getAttribute('data-pattern') || '';
        if (rule) {
          var ok;
          try { ok = new RegExp(rule).test(value); }
          catch (ex) { ok = true; } // regla mal escrita: no bloqueamos al cliente
          if (!ok) return fail();
        }

        var tpl = o.getAttribute('data-url') || '';
        if (tpl.indexOf('[NUM]') === -1) return fail(); // mal configurado: avisar, no callar

        // Sustituye TODAS las apariciones: algunos transportistas repiten el
        // número en la ruta y en un parámetro.
        var url = tpl.split('[NUM]').join(encodeURIComponent(value));

        sending = true;
        setTimeout(function () { sending = false; }, 1200);

        // OJO: window.open(url, '_blank', 'noopener') devuelve null POR ESPECIFICACIÓN
        // aunque la pestaña se abra, así que un guard "if (!win)" se cumple SIEMPRE y
        // la pestaña actual abandonaba la tienda además de abrir la del transportista.
        // Con un ancla sintética el navegador abre la pestaña nueva y no devuelve nada
        // que malinterpretar; el clic del usuario sigue siendo el gesto que la autoriza.
        var a = document.createElement('a');
        a.href = url;
        a.target = '_blank';
        a.rel = 'noopener noreferrer';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
